export default [
  {
    path: '/cms/blog',
    name: 'Blog',
    component: () => import(/* webpackChunkName: 'blog' */ './views/Blog.vue')
  },
  {
    path: '/cms/testimonial',
    name: 'Testimonial',
    component: () =>
      import(/* webpackChunkName: 'testimonial' */ './views/Testimonial.vue')
  },
  {
    path: '/cms/blog-author',
    name: 'Blog author',
    component: () =>
      import(/* webpackChunkName: 'author' */ './views/BlogAuthor.vue')
  },
  {
    path: '/cms/faq',
    name: 'FAQ',
    component: () => import(/* webpackChunkName: 'faq' */ './views/Faq.vue')
  },
  {
    path: '/cms/terms',
    name: 'Terms & Conditions',
    component: () => import(/* webpackChunkName: 'terms' */ './views/Terms.vue')
  },
  {
    path: '/cms/legal/privacy-policy',
    name: 'Privacy Policy',
    component: () => import(/* webpackChunkName: 'eula' */ './views/PrivacyPolicy.vue')
  },
  {
    path: '/cms/legal/cookie-policy',
    name: 'Cookie Policy',
    component: () => import(/* webpackChunkName: 'eula' */ './views/CookiePolicy.vue')
  },
  {
    path: '/cms/legal/eula',
    name: 'End User Licence Agreement',
    component: () => import(/* webpackChunkName: 'eula' */ './views/EULA.vue')
  },
  {
    path: '/cms/carousel/campaign-highlight',
    name: 'Campaign Highlight',
    component: () =>
      import(
        /* webpackChunkName: 'campaignHighlight' */ './views/CampaignHighlight.vue'
      )
  },
  {
    path: '/cms/affiliate',
    name: 'Affiliate',
    component: () =>
      import(/* webpackChunkName: 'affiliate' */ './views/Affiliate.vue')
  },
  {
    path: '/cms/pre-approved',
    name: 'Pre-approved',
    component: () =>
      import(/* webpackChunkName: 'pre-approved' */ './views/PreApproved.vue')
  },
  {
    path: '/cms/file-manager',
    name: 'File Manager',
    component: () =>
      import(/* webpackChunkName: 'fileManager' */ './views/FileManager.vue')
  },
  {
    path: '/cms/carousel/new-releases',
    name: 'New Releases',
    component: () =>
      import(
        /* webpackChunkName: 'newReleases-cms' */ './views/NewReleases.vue'
      )
  },
  {
    path: '/cms/carousel/community',
    name: 'Community',
    component: () =>
      import(/* webpackChunkName: 'community-cms' */ './views/Community.vue')
  },
  {
    path: '/cms/carousel/opportunities',
    name: 'Opportunities',
    component: () =>
      import(/* webpackChunkName: 'community-cms' */ './views/Opportunities.vue')
  },
  {
    path: '/cms/contracts',
    name: 'Contracts',
    component: () =>
        import(/* webpackChunkName: 'contracts' */ './views/Contracts.vue')
  },
  {
    path: '/cms/youtube',
    name: 'Assets',
    component: () =>
      import(
        /* webpackChunkName: 'youtube/dashboard' */ './views/YoutubeDashboard.vue'
      )
  },
  {
    path: '/cms/youtube/assets',
    name: 'Assets',
    component: () =>
      import(
        /* webpackChunkName: 'youtube/assets' */ './views/YoutubeAssets.vue'
      )
  },
  {
    path: '/cms/youtube/claims/removal',
    name: 'Claims for removal',
    component: () =>
      import(
        /* webpackChunkName: 'youtube/claims/removal' */ './views/YoutubeRemovalClaims.vue'
      )
  },
  {
    path: '/cms/youtube/claims',
    name: 'Claim Removal Requests',
    component: () =>
      import(
        /* webpackChunkName: 'youtube/claims' */ './views/YoutubeClaims.vue'
      )
  },
  {
    path: '/cms/youtube/licensing',
    name: 'Licensing',
    component: () =>
      import(
        /* webpackChunkName: 'youtube/licensing' */ './views/YoutubeLicensing.vue'
      )
  },
  {
    path: '/cms/youtube/reports',
    name: 'Youtube Reports',
    component: () =>
        import(
            /* webpackChunkName: 'youtube/reports' */ './views/YoutubeReports.vue'
            )
  },
  {
    path: '/cms/youtube/allowlist',
    name: 'Allowlist',
    component: () =>
      import(
        /* webpackChunkName: 'youtube/whitelist' */ './views/YoutubeWhitelist.vue'
      )
  },
  {
    path: '/cms/youtube/users',
    name: 'ContentId Users',
    component: () =>
        import(
            /* webpackChunkName: 'youtube/users' */ './views/YoutubeUsers.vue'
            )
  },
  {
    path: '/cms/youtube/keywords',
    name: 'ContentId Keywords',
    component: () =>
        import(
            /* webpackChunkName: 'youtube/keywords' */ './views/YoutubeKeywords.vue'
            )
  },
  {
    path: '/cms/youtube/claim-log',
    name: 'ContentId Claim Log',
    component: () =>
        import(
            /* webpackChunkName: 'youtube/keywords' */ './views/YoutubeClaimLog.vue'
            )
  },
  {
    path: '/cms/campaign-links',
    name: 'Signup links',
    component: () =>
        import(/* webpackChunkName: 'testimonial' */ './views/CampaignLinks.vue')
  },

  {
    path: '/cms/agreements',
    name: 'Agreements',
    component: () =>
        import(/* webpackChunkName: 'cms-agreements' */ './views/Agreement.vue')
  },
  {
    path: '/cms/youtube/managed-channels',
    name: 'Managed Channels',
    component: () =>
        import(
            /* webpackChunkName: 'youtube/users' */ './views/McnChannels.vue'
            )
  },
  {
    path: '/cms/youtube/channel-video-claims',
    name: 'Channel Video Claims',
    component: () =>
        import(
            /* webpackChunkName: 'youtube/channel-video-claims' */ './views/ChannelVideoClaims.vue'
            )
  },
  {
    path: '/cms/youtube/revenue-share-campaigns',
    name: 'Revenue Share Campaigns',
    component: () =>
        import(
            './views/RevShareCampaigns.vue'
            )
  },
]
